import React from "react";
import moment from "moment";

import { fetchApi } from "../../Network/NetworkService";
import { notif } from "../Ui/Notification";

import "../../Assets/Pages/dermatoSdr.css";
import IconTooltip from "../Ui/IconTooltip";
import { typeStates } from "../../Constants";

// Colour cue for the skin-evolution answer (q1): green = improving, red = worsening.
const Q1_COLOR = {
  "Forte amélioration": "#2e7d32",
  "Légère amélioration": "#558b2f",
  "Aucun changement": "#f9a825",
  "Cela s'aggrave": "#c62828",
};

const fmtPct = (r) => (r * 100).toFixed(1) + " %";
const fmtDelay = (d) =>
  d == null ? "—" : d < 1 ? "< 1 j" : Math.round(d) + " j";

class DermatoSdrCompletions extends React.Component {
  constructor() {
    super();
    const end = moment().format("YYYY-MM-DD");
    const start = moment().subtract(29, "days").format("YYYY-MM-DD");
    this.state = {
      startDate: start,
      endDate: end,
      stats: null,
      q1Distribution: [],
      users: [],
      loading: false,
      loaded: false,
      page: 1,
      totalPage: 0,
      countUsers: 0,
      type: "dermatologie",
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { startDate, endDate, page, type } = this.state;
    this.setState({ loading: true });
    fetchApi(
      "/dermato-sdr/completions?start=" +
        startDate +
        "&end=" +
        endDate +
        "&type=" +
        type +
        "&page=" +
        page,
    )
      .then((res) => {
        // fetchApi already rejects when success === false, so anything reaching
        // here is a successful response.
        this.setState({
          stats: res.stats || null,
          q1Distribution: res.q1Distribution || [],
          users: res.users || [],
          totalPage: res.countPages || 0,
          countUsers: res.countUsers || 0,
          loaded: true,
          loading: false,
        });
      })
      .catch((err) => {
        // fetchApi rejects with the server's `message` string on a {success:false}
        // body (e.g. RANGE_TOO_WIDE "Période trop large…"); surface it instead of
        // a generic toast. Network/parse failures reject with an Error object.
        const message =
          typeof err === "string"
            ? err
            : "Erreur de récupération des complétions";
        notif.addNotification("Erreur", message, "warning");
        this.setState({ loading: false });
      });
  };

  applyFilter = () => {
    this.setState({ page: 1, users: [] }, this.fetchData);
  };

  updatePage(page) {
    this.setState({ users: [], page, loading: true }, this.fetchData);
  }

  renderKpis() {
    const { stats } = this.state;
    if (!stats) return null;
    const cards = [
      { label: "Emails envoyés", value: stats.sentUsers, color: "#14375F" },
      { label: "Complétés", value: stats.completedUsers, color: "#2e7d32" },
      {
        label: "Taux de complétion",
        value: fmtPct(stats.completionRate),
        color: "#F2718A",
      },
      {
        label: "Escalations",
        value: stats.escalations,
        color: stats.escalations > 0 ? "#c62828" : "#888",
        hint: "Aggravation + souhaite reconsulter",
      },
      {
        label: "Délai moyen",
        value: fmtDelay(stats.avgDelayDays),
        color: "#14375F",
        hint: "Entre l'envoi et la complétion",
      },
      {
        label: "Dont relancés",
        value: stats.relancedUsers,
        color: "#e65100",
        hint: "Patients ayant reçu une relance",
      },
    ];
    return (
      <div className="dermato-sdr-kpis">
        {cards.map((c) => (
          <div className="dermato-sdr-kpi" key={c.label}>
            <div className="dermato-sdr-kpi-value" style={{ color: c.color }}>
              {c.value}
            </div>
            <div className="dermato-sdr-kpi-label">{c.label}</div>
            {c.hint ? (
              <div className="dermato-sdr-kpi-hint">{c.hint}</div>
            ) : null}
          </div>
        ))}
      </div>
    );
  }

  renderQ1() {
    const { q1Distribution } = this.state;
    if (!q1Distribution.length) return null;
    const total = q1Distribution.reduce((a, d) => a + d.count, 0) || 1;
    return (
      <div className="dermato-sdr-card" style={{ marginTop: 24 }}>
        <h3 className="dermato-sdr-card-title">{"Évolution de la peau"}</h3>
        {q1Distribution.map((d) => (
          <div className="dermato-sdr-bar-row" key={d.label}>
            <span className="dermato-sdr-bar-label">{d.label}</span>
            <div className="dermato-sdr-bar-track">
              <div
                className="dermato-sdr-bar-fill"
                style={{
                  width: (d.count / total) * 100 + "%",
                  background: Q1_COLOR[d.label] || "#90a4ae",
                }}
              />
            </div>
            <span className="dermato-sdr-bar-count">{d.count}</span>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const {
      startDate,
      endDate,
      users,
      loading,
      loaded,
      page,
      totalPage,
      countUsers,
    } = this.state;

    return (
      <div className="dermato-sdr-container">
        <div className="dermato-sdr-header">
          <h2 className="dermato-sdr-title">{"Complétions Dermato SDR"}</h2>
          <button
            className="dermato-sdr-btn dermatosdr-btn-link"
            onClick={() => this.props.history.push("/dermato-sdr")}
          >
            {"← Retour aux envois"}
          </button>
        </div>

        <div className="dermato-sdr-card">
          <h3 className="dermato-sdr-card-title">{"Période d'envoi"}</h3>
          <div className="dermato-sdr-inline">
            <div className="dermato-sdr-form-group">
              <label>{"Type"}</label>
              <select
                className="dermato-sdr-input"
                value={this.state.type}
                onChange={(e) => this.setState({ type: e.target.value })}
              >
                {typeStates.map((t) => (
                  <option value={t.value}>{t.label}</option>
                ))}
              </select>
            </div>
            <div className="dermato-sdr-form-group">
              <label>{"Du"}</label>
              <input
                type="date"
                className="dermato-sdr-input"
                value={startDate}
                max={endDate}
                onChange={(e) => this.setState({ startDate: e.target.value })}
              />
            </div>
            <div className="dermato-sdr-form-group">
              <label>{"Au"}</label>
              <input
                type="date"
                className="dermato-sdr-input"
                value={endDate}
                min={startDate}
                onChange={(e) => this.setState({ endDate: e.target.value })}
              />
            </div>
            <div
              className="dermato-sdr-form-group"
              style={{ justifyContent: "flex-end" }}
            >
              <label style={{ visibility: "hidden" }}>.</label>
              <button
                className="dermato-sdr-btn dermatosdr-btn-primary"
                disabled={loading}
                onClick={this.applyFilter}
              >
                {loading ? "Chargement…" : "Rafraîchir"}
              </button>
            </div>
          </div>
          <p style={{ margin: "12px 0 0", color: "#888", fontSize: 13 }}>
            {
              "Cohorte = patients ayant reçu un premier email de suivi sur la période. Une complétion est attribuée à l'envoi seulement si elle a eu lieu après celui-ci."
            }
          </p>
        </div>

        {this.renderKpis()}
        {this.renderQ1()}

        <div className="dermato-sdr-card" style={{ marginTop: 24 }}>
          <h3 className="dermato-sdr-card-title">
            {"Patients ayant complété"} ({countUsers})
          </h3>

          {loading ? (
            <div className="dermato-sdr-empty">
              <span className="loader" />
            </div>
          ) : loaded && users.length === 0 ? (
            <div className="dermato-sdr-empty">
              {"Aucune complétion sur cette période."}
            </div>
          ) : users.length > 0 ? (
            <div>
              <table className="dermato-sdr-table">
                <thead>
                  <tr>
                    <th>Patient</th>
                    <th>{"Médecin"}</th>
                    <th>{"Envoyé le"}</th>
                    <th>{"Complété le"}</th>
                    <th>{"Délai"}</th>
                    <th>{"Évolution"}</th>
                    <th>{"Poursuite"}</th>
                    <th>Photos</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((u) => (
                    <tr key={u._id}>
                      <td>
                        <div style={{ fontWeight: 600 }}>
                          {(u.FName || "") + " " + (u.LName || "")}
                        </div>
                        <div style={{ color: "#888", fontSize: 12 }}>
                          {u.email}
                        </div>
                      </td>
                      <td>
                        {u.doctor && (u.doctor.FName || u.doctor.LName)
                          ? "Dr " +
                            (u.doctor.FName || "") +
                            " " +
                            (u.doctor.LName || "")
                          : "—"}
                      </td>
                      <td>
                        {u.sentAt ? moment(u.sentAt).format("DD/MM/YYYY") : "—"}
                      </td>
                      <td>
                        {u.completedAt
                          ? moment(u.completedAt).format("DD/MM/YYYY HH:mm")
                          : "—"}
                      </td>
                      <td>{fmtDelay(u.delayDays)}</td>
                      <td
                        style={{
                          color: Q1_COLOR[u.q1] || "#14375F",
                          fontWeight: 600,
                        }}
                      >
                        {u.q1 || "—"}
                      </td>
                      <td>{u.q3 || "—"}</td>
                      <td>{u.photoCount > 0 ? u.photoCount : "—"}</td>
                      <td>
                        {u.requiresAttention ? (
                          <span className="dermato-sdr-badge dermato-sdr-badge-relance">
                            {"⚠ Attention"}
                          </span>
                        ) : null}
                        {u.relanced ? (
                          <span
                            className="dermato-sdr-badge dermato-sdr-badge-send"
                            style={{ marginLeft: 4 }}
                          >
                            {"Relancé"}
                          </span>
                        ) : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="dermatosdr-pagination">
                <p style={{ margin: 0, color: "#888", fontSize: 14 }}>
                  Page <strong>{page}</strong> / {totalPage}
                </p>
                <div>
                  {page > 1 && (
                    <IconTooltip
                      icon="fa fa-chevron-left"
                      text="Page précédente"
                      onClick={() => this.updatePage(page - 1)}
                    />
                  )}
                  {page < totalPage && (
                    <IconTooltip
                      icon="fa fa-chevron-right"
                      text="Page suivante"
                      onClick={() => this.updatePage(page + 1)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default DermatoSdrCompletions;
